import { BankOfHoursBalancesDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import BankOfHoursUtils from 'modules/attendance/lib/utils/BankOfHoursUtils'

type Props = {
  employeeId: number
  startOn?: string
  endOn?: string
  skip?: boolean
  useComplementaryHoursLabels?: boolean
}

export const useBankOfHoursMovements = ({
  employeeId,
  startOn,
  endOn,
  skip,
  useComplementaryHoursLabels = false,
}: Props) => {
  const shouldSkip = skip || !startOn || !endOn

  const { loading, data } = useQuery(BankOfHoursBalancesDocument, {
    variables: { startOn: startOn ?? '', endOn: endOn ?? '', employeeId },
    fetchPolicy: 'cache-first',
    skip: shouldSkip,
  })

  const bankOfHoursBalances = shouldSkip ? [] : data?.attendance?.employee?.attendanceBalances ?? []
  const bankOfHoursMovements = BankOfHoursUtils.buildMovements(bankOfHoursBalances, {
    useComplementaryHoursLabels,
  })
  const totalMinutes = bankOfHoursMovements.reduce(
    (accumulator, movement) => accumulator + movement.minutes,
    0
  )

  return {
    bankOfHoursMovements,
    isLoading: shouldSkip ? false : loading,
    totalMinutes,
  }
}
